import authSlice from "../slices/Auth.slice";
import AppSlice from "../slices/App.slice";
import supplierSlice from "../slices/Supplier.slice";
import collectionSlice from "../slices/Collections.slice";
import userManagementSlice from "../slices/UserManagement.slice";
import farmManagementSlice from "../slices/FarmManagement.slice";
import utilitySlice from "../slices/Utility.slice";
import cashAdvanceSlice from "../slices/CashAdavance.slice";
import dashboardSlice from "../slices/Dashboard.slice";
import communicationSlice from "../slices/Communication.slice";
import ConfigurationsSlice from "../slices/Configurations.slice";
import inputTrackingSlice from "../slices/InputTracking.slice";
import paymentSlice from "../slices/Payment.slice";

export const reducers = {
  Auth: authSlice.reducer,
  App: AppSlice.reducer,
  Dashboard: dashboardSlice.reducer,
  Supplier: supplierSlice.reducer,
  Collections: collectionSlice.reducer,
  UserManagement: userManagementSlice.reducer,
  Utility: utilitySlice.reducer,
  Input: inputTrackingSlice.reducer,
  CashAdvance: cashAdvanceSlice.reducer,
  Communication: communicationSlice.reducer,
  Configurations: ConfigurationsSlice.reducer,
  FarmManagement: farmManagementSlice.reducer,
  Payment: paymentSlice.reducer
};
